import React, {useEffect, useState} from 'react';
import {deleteImagesAndFiles, getFile, getImagesAndFiles, uploadImagesAndFiles} from "../../api/file/FileService";
import {XCircleIcon} from "@heroicons/react/24/solid";
import Excel from "../../resources/icon/excel-icon.png";
import Pwpoint from "../../resources/icon/ppt-icon.png";
import Word from "../../resources/icon/word-icon.png";
import Pdf from "../../resources/icon/pdf-icon.png";
import Doc from "../../resources/icon/documnet-icon.png";
import IMG from "../../resources/icon/img-upload.png";
import styled from "styled-components";
import {handleActiveToast} from "../sonner/ToastBasic";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {apiLoading} from "../../redux/slice/apiSlice";

const Img = styled.img`
    width: 20px;
    height: 20px;
`;

const TextViewFileUpdater = ({tableInfo, isSingle, onlyImage, nativeInput, inline, uploadLabel, readOnly}) => {
    const [files, setFiles] = useState([]);

    const {t} = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        handleGetFileList();
    }, [tableInfo.joinKey]);

    const handleGetFileList = async () => {
        try {
            dispatch(apiLoading(true));
            const type = onlyImage ? "IMG" : "FILE";
            const response = await getImagesAndFiles(tableInfo.tableName, tableInfo.joinKey, type);
            if (response && response.status === 200) {
                setFiles([...response.data])
            }
        } finally {
            dispatch(apiLoading(false));
        }
    }

    const handleFilChange = async (e) => {
        try {
            const uploadFiles = e.target.files;

            if (onlyImage) {
                for (let i = 0; i < uploadFiles.length; i++) {
                    if (!uploadFiles[i].type.startsWith('image/')) {
                        alert("이미지 파일만 업로드 가능합니다.");
                        e.target.value = null; // 입력 초기화
                        return;
                    }
                }
            }

            dispatch(apiLoading(true));
            if (tableInfo) {
                if (window.confirm("업로드하시겠습니까?")) {
                    const uploadFiles = e.target.files;
                    let response
                    if (onlyImage) {
                        response = await uploadImagesAndFiles(uploadFiles, [], tableInfo);
                    } else {
                        response = await uploadImagesAndFiles([], uploadFiles, tableInfo);
                    }
                    if (response && response === 200) {
                        handleGetFileList();
                        handleActiveToast({message: t(`saved`)});
                        e.target.value = "";
                    }
                }
            }
        } finally {
            dispatch(apiLoading(false));
        }
    }

    const handleDelete = async (id) => {
        try {
            dispatch(apiLoading(true));
            if (tableInfo) {
                if (window.confirm(t(`confirmRemove`))) {
                    const status = await deleteImagesAndFiles(id);
                    if (status === 200) {
                        handleGetFileList();
                        handleActiveToast({message: t(`removed`)});
                    }
                }
            }
        } finally {
            dispatch(apiLoading(false));
        }
    }

    const handleDownload = async (file) => {
        try {
            dispatch(apiLoading(true));
            await getFile(file);
        } finally {
            dispatch(apiLoading(false));
        }
    }

    const handleSetExtImage = (ext) => {
        if (['xls', 'xlsx'].includes(ext)) {
            return <Img src={Excel}/>
        } else if (['powerpoint', 'pptx', 'ppt'].includes(ext)) {
            return <Img src={Pwpoint}/>
        } else if (['word', 'docx'].includes(ext)) {
            return <Img src={Word} />
        } else if (ext === ('pdf')) {
            return <Img src={Pdf}/>
        } else if (['png', 'jpg', 'jpeg'].includes(ext)) {
            return <Img src={IMG}/>
        } else {
            return <Img src={Doc}/>
        }
    }

    const renderFileInput = () => (
        nativeInput ? (
            <input
                className="text-view-file-updater__input"
                type="file"
                multiple={!isSingle}
                accept={onlyImage ? "image/*" : "*"}
                onChange={handleFilChange}
            />
        ) : (
            <div className="w-[15rem]">
                <label className="px-6 py-1 b-gray bg-white item-center cursor-pointer" htmlFor="file_doc">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                         className="w-4 h-4 inline-block mr-2">
                        <path
                            d="M9.25 13.25a.75.75 0 0 0 1.5 0V4.636l2.955 3.129a.75.75 0 0 0 1.09-1.03l-4.25-4.5a.75.75 0 0 0-1.09 0l-4.25 4.5a.75.75 0 1 0 1.09 1.03L9.25 4.636v8.614Z"/>
                        <path
                            d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z"/>
                    </svg>
                    <span>{onlyImage ? "내 PC에서 이미지 찾기" : "내 PC에서 파일 찾기"}</span>
                </label>
                <input
                    className="hidden"
                    id="file_doc"
                    type="file"
                    multiple={!isSingle}
                    accept={onlyImage ? "image/*" : "*"}
                    onChange={handleFilChange}
                />
            </div>
        )
    );

    const renderFileList = () => (
        <div className={`text-view-file-updater__list${inline ? "" : " my-2 border border-[#dadde0] min-h-20 p-2 flex flex-col gap-1"}`}>
            {files.length > 0 && files.map((file, index) => (
                <div
                    className={`${inline ? "text-view-file-updater__list-item" : ""} flex gap-2`}
                    key={index}
                >
                    {!readOnly && (
                        <XCircleIcon
                            className="w-5 h-5 hover:text-[#bd1111] cursor-pointer shrink-0"
                            title="삭제"
                            onClick={() => handleDelete(file.id)}
                        />
                    )}
                    {handleSetExtImage(file.ext)}
                    <div
                        className={`text-[13px] min-w-0 flex-1 ${!onlyImage ? "hover:underline cursor-pointer" : ""} truncate`}
                        onClick={onlyImage ? undefined : () => handleDownload(file)}
                    >
                        {file.originalName}
                    </div>
                </div>
            ))}
            {files.length === 0 && (
                <div className={`text-[#b1bac3] text-[13px]${inline ? " text-view-file-updater__list-empty" : " p-3"}`}>
                    다운로드 가능한 파일이 없습니다.
                </div>
            )}
        </div>
    );

    if (readOnly) {
        return (
            <div className="text-view-file-updater text-view-file-updater--readonly">
                {renderFileList()}
            </div>
        );
    }

    if (inline) {
        return (
            <div className={`text-view-file-updater text-view-file-updater--inline ${nativeInput ? "text-view-file-updater--native" : ""}`.trim()}>
                <div className="code-editor__field--inline text-view-file-updater__picker-row">
                    {uploadLabel && (
                        <label className="code-editor__inline-label">{uploadLabel}</label>
                    )}
                    {(!isSingle || files.length === 0) && renderFileInput()}
                </div>
                {renderFileList()}
            </div>
        );
    }

    return (
        <div className={nativeInput ? "text-view-file-updater text-view-file-updater--native" : "text-view-file-updater"}>
            {(!isSingle || files.length === 0) && renderFileInput()}
            {renderFileList()}
        </div>
    );
};

export default TextViewFileUpdater;